// Dependencies
var $ = jQuery;

function disable(element, delay) {
    element.addClass('is-disabled');

    setTimeout(function() {
        element.removeClass('is-disabled');
    }, delay);
}

function isDesktop() {
    if( $(window).width() >= 1280 ) {
        return true;
    }
}

function isHomePage() {
    return $('body').hasClass('index');
}

function updateCart() {
    var cartTotal = $('.cart-link');

    $.get({
        url: '/',
        success: function(data) {
            var newTotal = $(data).find('.cart-link');
            cartTotal.replaceWith(newTotal); // Update Total
        }
    });
}

function matchHeights() {
    $('.collection-item__heading').matchHeight();
    $('.collection-item__options').matchHeight();
}